
import React, { useState, useEffect } from "react";
import "./Pagination.css";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';

function Pagination({chunkData, setTableData}) {
    
    const [pagesTable, setPagesTable] = useState([]);
    const [activePage, setActivePage] = useState(1);
    
    useEffect(() => {
        
        let pageNumbers = new Array();
        for (let i = 0; i < chunkData.length; i++) {
            pageNumbers.push(i + 1);
        }
        setPagesTable(pageNumbers);
        if (chunkData.length < activePage) {
            setTableData(chunkData[0]);
        }
        else {
            setTableData(chunkData[activePage - 1]);
        }
    }, [chunkData]);
    
    const goPrevPage = () => {
        if (activePage === 1) {
            return null;
        }
        else {
            setActivePage(activePage => --activePage);                    
        }
    }
    
    const clickOnPage = (item) => {
        setActivePage(item);
    }
    
    const goNextPage = () => {
        if (activePage === chunkData.length) {
            return null;
        }
        else {
            setActivePage(activePage => ++activePage);
        }
    }
    
    useEffect(() => {
        setTableData(chunkData[activePage - 1]);
    },[activePage])

    return(
        <div className="PaginationBox">
            <KeyboardArrowLeftIcon 
                style={{
                    color: activePage === 1 ? "#BBBBBB" : "#3F68B1",
                    fontSize: "25px", 
                    cursor: "pointer"
                }} 
                onClick = { goPrevPage }
            />
            {
                pagesTable.map((item, index) =>
                    <span
                        key = { index }
                        className = "pageNumber"
                        onClick = { clickOnPage.bind(this, item) }
                        style = {{
                            border: activePage === item ? "1px solid #3F68B1" : "none"
                        }}
                    >
                        { item }
                    </span>
                )
            }
            <KeyboardArrowRightIcon 
                style = {{
                    color: activePage === chunkData.length ? "#BBBBBB" :"#3F68B1",
                    fontSize: "25px", 
                    cursor: "pointer"
                }} 
                onClick = { goNextPage }
            />
        </div>
    )
}

export default Pagination


